(() => {
  const money = (cents, currency) => {
    if (window.Shopify?.formatMoney && window.Shopify?.money_format) return window.Shopify.formatMoney(cents, window.Shopify.money_format);
    try { return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency }).format(Number(cents) / 100); }
    catch { return `${(Number(cents) / 100).toFixed(2)} ${currency}`; }
  };

  document.querySelectorAll('[data-family-picker]').forEach((picker) => {
    const form = picker.closest('form');
    const variantInput = form?.querySelector('[data-family-variant-id]');
    const addButton = form?.querySelector('button[name="add"]');
    const price = document.querySelector('[data-family-price-display]');
    const gallery = document.querySelector('[data-family-gallery]');
    const intro = document.querySelector('[data-family-intro]');
    const title = document.querySelector('[data-family-title]');
    const description = document.querySelector('[data-family-description]');
    const officeAppsList = document.querySelector('[data-office-apps-list]');
    const deliveryLabel = document.querySelector('[data-family-delivery-label]');
    const availability = document.querySelector('[data-family-availability]');
    if (!form || !variantInput || !addButton || !price || !window.Rdr21ProductSelection) return;
    const selection = window.Rdr21ProductSelection;
    const state = selection.guard(form, variantInput);

    const updateLinks = () => {
      picker.querySelectorAll('a[data-family-product-url]').forEach((option) => {
        const key = picker.dataset.familyVariantKey;
        const variants = JSON.parse(option.dataset.familyVariants || '[]');
        const id = key && variants.length ? variants.find((item) => item.title === key)?.id : option.dataset.familyVariant;
        if (id) {
          option.href = selection.url(option.dataset.familyProductUrl, id);
          option.removeAttribute('aria-disabled');
        } else option.setAttribute('aria-disabled', 'true');
      });
    };
    updateLinks();

    let sequence = 0;
    const renderHtml = (html) => {
      const template = document.createElement('template');
      template.innerHTML = html || '';
      template.content.querySelectorAll('script, iframe, object, embed, form').forEach((node) => node.remove());
      template.content.querySelectorAll('*').forEach((node) => [...node.attributes].forEach((attribute) => {
        if (/^on/i.test(attribute.name) || (attribute.name === 'href' || attribute.name === 'src') && /^\s*javascript:/i.test(attribute.value)) node.removeAttribute(attribute.name);
      }));
      return template.content;
    };
    const renderOfficeApps = (appsValue) => {
      if (!officeAppsList) return;
      const allowedApps = new Set(['word', 'excel', 'powerpoint', 'outlook', 'onenote', 'access', 'publisher', 'onedrive', 'teams', 'sharepoint']);
      const apps = [...new Set((appsValue || '').split(',').map((app) => app.trim()).filter((app) => allowedApps.has(app)))];
      officeAppsList.replaceChildren(...apps.map((app) => {
        const item = document.createElement('li');
        item.className = 'rdr21-office-apps__item';
        const image = document.createElement('img');
        image.src = `${officeAppsList.dataset.officeAssetPrefix}${app}.svg`;
        image.width = 40;
        image.height = 40;
        image.loading = 'lazy';
        image.alt = '';
        image.setAttribute('aria-hidden', 'true');
        const label = document.createElement('span');
        label.textContent = officeAppsList.dataset[`label${app[0].toUpperCase()}${app.slice(1)}`] || app;
        item.append(image, label);
        return item;
      }));
      officeAppsList.closest('.rdr21-office-apps')?.toggleAttribute('hidden', apps.length === 0);
    };
    const select = async (card, navigateOnFailure = true, variantKeyOverride = '', historyMode = 'push') => {
      const current = ++sequence;
      card.setAttribute('aria-busy', 'true');
      state.busy(true);
      try {
        const response = await fetch(card.dataset.familyJsonUrl, { headers: { Accept: 'application/json' }, signal: AbortSignal.timeout(12000) });
        if (!response.ok) throw new Error('Product data unavailable');
        const product = await response.json();
        if (current !== sequence) return;
        if (product.handle !== card.dataset.familyHandle) throw new Error('Unexpected product.');
        const variantKey = variantKeyOverride || picker.dataset.familyVariantKey || '';
        const variantId = Number(card.dataset.familyVariant);
        const requestedId = historyMode === 'none' ? new URL(window.location.href).searchParams.get('variant') : null;
        const variant = variantKey ? product.variants?.find((item) => item.title === variantKey)
          : requestedId ? product.variants?.find((item) => String(item.id) === requestedId)
            : product.variants?.find((item) => Number(item.id) === variantId);
        if (!variant) {
          const error = new Error('Selected variant does not exist.');
          error.variantMissing = true;
          throw error;
        }

        if (!state.commit(variant, product)) throw new Error('Invalid variant data.');
        await state.refreshPaymentButton(card.dataset.familyProductUrl, product, variant);
        if (current !== sequence) return;
        const currentPrice = price.querySelector('[data-price-current]');
        const comparePrice = price.querySelector('[data-price-compare]');
        const saleDeadline = document.querySelector('[data-sale-deadline]');
        const currency = price.querySelector('small')?.textContent?.trim() || 'EUR';
        const hasCompare = Number(variant.compare_at_price) > Number(variant.price);
        if (currentPrice) currentPrice.textContent = money(variant.price, currency);
        if (comparePrice) {
          comparePrice.hidden = !hasCompare;
          comparePrice.textContent = hasCompare ? money(variant.compare_at_price, currency) : '';
        }
        if (saleDeadline) saleDeadline.hidden = !hasCompare;
        const selectedDeliveryScope = card.dataset.familyDeliveryScope;
        if (deliveryLabel && selectedDeliveryScope) {
          deliveryLabel.textContent = selectedDeliveryScope === 'office_account'
            ? picker.dataset.familyDeliveryAccount
            : picker.dataset.familyDeliveryKey;
        }
        const availabilityLabel = availability?.querySelector('[data-family-availability-label]');
        if (availabilityLabel) availabilityLabel.textContent = variant.available
          ? availability.dataset.familyAvailableLabel
          : availability.dataset.familyUnavailableLabel;
        const familyTitle = picker.dataset.familyDisplayTitle;
        const selectedTitle = picker.dataset.family === 'eset_nod32' ? familyTitle : card.dataset.familyTitle || product.title || familyTitle;
        if (title) title.textContent = selectedTitle;
        const subnavTitle = document.querySelector('.rdr21-product-subnav__title');
        if (subnavTitle) {
          subnavTitle.textContent = selectedTitle;
        }
        if (intro) intro.textContent = card.dataset.familySummary || '';
        if (picker.dataset.family === 'office_365') renderOfficeApps(card.dataset.familyApps || '');
        if (description) description.replaceChildren(renderHtml(product.description));
        if (gallery && Array.isArray(product.images) && product.images.length) {
          gallery.replaceChildren(...product.images.map((src) => {
            const image = document.createElement('img'); image.src = src; image.alt = product.title; image.loading = 'lazy'; return image;
          }));
        }
        picker.querySelectorAll('[data-family-product-url]').forEach((option) => {
          const selected = option === card;
          option.classList.toggle('is-selected', selected);
          if (selected) option.setAttribute('aria-current', 'true'); else option.removeAttribute('aria-current');
        });
        updateLinks();
        const selectedUrl = selection.url(card.dataset.familyProductUrl, variant.id);
        if (historyMode === 'push') window.history.pushState({ productId: product.id }, '', selectedUrl);
        if (historyMode === 'replace') window.history.replaceState({ productId: product.id }, '', selectedUrl);
        const storeName = document.title.split('|').pop()?.trim() || 'RDR Software';
        document.title = `${selectedTitle} | ${storeName}`;
      } catch (error) {
        if (current !== sequence) return;
        state.block();
        if (navigateOnFailure && !error.variantMissing) window.location.assign(card.href);
      } finally {
        card.removeAttribute('aria-busy');
        if (current === sequence) state.busy(false);
      }
    };

    const syncServerPrices = () => {
      const sources = [...picker.querySelectorAll('a[data-family-product-url][data-family-server-year]')];
      if (!sources.length) return;
      const selectedYear = picker.querySelector('button[data-family-server-year][aria-pressed="true"]')?.dataset.familyServerYear;
      picker.querySelectorAll('button[data-family-server-year]').forEach((button) => {
        const yearSources = sources
          .filter((source) => source.dataset.familyServerYear === button.dataset.familyServerYear)
          .sort((a, b) => Number(a.dataset.familyPriceCents) - Number(b.dataset.familyPriceCents));
        const cheapest = yearSources[0];
        const priceLabel = button.querySelector('[data-server-year-price]');
        button.disabled = !cheapest;
        button.setAttribute('aria-disabled', String(!cheapest));
        if (priceLabel) priceLabel.textContent = cheapest
          ? button.dataset.familyFromTemplate.replace('__PRICE__', cheapest.dataset.familyPrice)
          : picker.querySelector('.rdr21-server-picker')?.dataset.familyUnavailableLabel || '';
      });
      picker.querySelectorAll('button[data-family-server-type]').forEach((button) => {
        const source = sources.find((item) => item.dataset.familyServerYear === selectedYear && item.dataset.familyServerType === button.dataset.familyServerType);
        const priceLabel = button.querySelector('[data-server-type-price]');
        if (priceLabel) priceLabel.textContent = source?.dataset.familyPrice || picker.querySelector('.rdr21-server-picker')?.dataset.familyUnavailableLabel || '';
        button.disabled = !source;
        button.setAttribute('aria-disabled', String(!source));
      });
    };
    syncServerPrices();

    picker.addEventListener('click', (event) => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
      const serverChoice = event.target.closest('[data-family-server-year], [data-family-server-type]');
      if (serverChoice) {
        event.preventDefault();
        const isYear = serverChoice.hasAttribute('data-family-server-year');
        const selector = isYear ? 'button[data-family-server-year]' : 'button[data-family-server-type]';
        picker.querySelectorAll(selector).forEach((choice) => {
          const selectedChoice = choice === serverChoice;
          choice.classList.toggle('is-selected', selectedChoice);
          choice.setAttribute('aria-pressed', selectedChoice ? 'true' : 'false');
        });
        syncServerPrices();
        const year = picker.querySelector('[data-family-server-year][aria-pressed="true"]')?.dataset.familyServerYear;
        const type = picker.querySelector('[data-family-server-type][aria-pressed="true"]')?.dataset.familyServerType;
        const source = [...picker.querySelectorAll('a[data-family-product-url][data-family-server-year]')].find((item) => item.dataset.familyServerYear === year && item.dataset.familyServerType === type);
        if (source) select(source); else state.block();
        return;
      }
      const platformChoice = event.target.closest('[data-family-platform]');
      if (platformChoice) {
        event.preventDefault();
        picker.dataset.familyVariantKey = platformChoice.dataset.familyPlatform;
        updateLinks();
        picker.querySelectorAll('[data-family-platform]').forEach((choice) => {
          const selectedPlatform = choice === platformChoice;
          choice.classList.toggle('is-selected', selectedPlatform);
          choice.setAttribute('aria-pressed', selectedPlatform ? 'true' : 'false');
        });
        const selectedYear = picker.querySelector('a[data-family-product-url][aria-current="true"]');
        if (selectedYear) select(selectedYear, true, picker.dataset.familyVariantKey);
        return;
      }
      const card = event.target.closest('a[data-family-product-url]');
      if (!card) return;
      if (card.getAttribute('aria-disabled') === 'true') { event.preventDefault(); return; }
      event.preventDefault(); select(card);
    });
    const selected = picker.querySelector('a[aria-current="true"]');
    if (selected) {
      const family = picker.dataset.family;
      const heading = document.querySelector('.rdr21-product-subnav__title');
      if (heading) {
        heading.textContent = family === 'eset_nod32' ? picker.dataset.familyDisplayTitle || selected.dataset.familyTitle || heading.textContent : selected.dataset.familyTitle || picker.dataset.familyDisplayTitle || heading.textContent;
      }
    }
    window.addEventListener('popstate', () => {
      if (!picker.dataset.family.startsWith('adobe_')) { window.location.reload(); return; }
      const path = window.location.pathname.replace(/\/$/, '');
      const card = [...picker.querySelectorAll('a[data-family-product-url]')].find((option) => new URL(option.dataset.familyProductUrl, window.location.origin).pathname.replace(/\/$/, '') === path);
      if (card) select(card, false, '', 'none').catch(() => window.location.reload());
      else window.location.reload();
    });
  });
})();
